import React, {useState} from 'react';
import {AssetResponseItem, GenericAsset, MediaAsset} from "@/@types/AssetTypes.ts";
import {Bookmark, ChevronLeft, ChevronRight, Heart, MessageCircle, Send} from 'lucide-react';
import DisplayRelativeTime from "@/components/DisplayRelativeTime.tsx";

function InstagramPostPreview({
     post,
     account,
     post_at,
    metrics,
     }: {
    account?: AssetResponseItem['account']
    metrics?: AssetResponseItem['metrics'],
    post_at?: string
    post: GenericAsset['post']}) {
    return (
        <InstagramCarousel account={account}
                           metrics={ metrics}
            postData={post} post_at={post_at}
        />
    );
}



const InstagramCarousel = ({
                               postData,
                               account,
    metrics,
                               post_at
                           }: {
    account?: AssetResponseItem['account']
    metrics?: AssetResponseItem['metrics'],
    post_at?: string
    postData: GenericAsset['post']}) => {
    const [activeSlide, setActiveSlide] = useState(0);

    // Sample data for a post
    // const post = {
    //     username: "traveler_photography",
    //     avatar: "/api/placeholder/50/50",
    //     // location: "Santorini, Greece",
    //     images: [
    //         "/api/placeholder/600/600",
    //         "/api/placeholder/600/600",
    //         "/api/placeholder/600/600",
    //         "/api/placeholder/600/600"
    //     ],
    //     likes: 2543,
    //     caption: "Beautiful sunset views from Santorini. The perfect end to a perfect day exploring the island. #travel #greece #sunset",
    //     comments: 128,
    //     postedTime: "2 hours ago"
    // };

    // Go to next slide
    const nextSlide = () => {
        setActiveSlide((prev) => (prev === postData.assets.length - 1 ? 0 : prev + 1));
    };

    // Go to previous slide
    const prevSlide = () => {
        setActiveSlide((prev) => (prev === 0 ? postData.assets.length - 1 : prev - 1));
    };

    return (
        <div className="overflow-hidden">
            {/* Post header */}
            <div className="flex items-center p-3">
                <div className="h-8 w-8 rounded-full overflow-hidden mr-3">
                    <img src={account?.picture?.url} alt={" "} className="h-full w-full object-cover"/>
                    {/*<Avatar alt={account?.username || ' '} src={account?.picture?.url} size={'100%'}/>*/}
                </div>
                <div className="flex-1">
                    <div className="font-semibold">{account?.username}</div>
                    {/*<div className="text-xs text-gray-500">{post.location}</div>*/}
                </div>
                <div className="text-gray-500">•••</div>
            </div>

            {/* Carousel */}
            <div className="relative">
                <div className="overflow-hidden">
                    <div
                        className="flex transition-transform duration-300 ease-in-out"
                        style={{ transform: `translateX(-${activeSlide * 100}%)` }}
                    >
                        {postData.assets.map((image, index) => (
                            <div className="min-w-full" key={index}>
                                <img src={(image.data as MediaAsset).url} alt={`Slide ${index + 1}`} className="w-full object-cover aspect-square" />
                            </div>
                        ))}
                    </div>
                </div>

                {/* Navigation buttons */}
                {activeSlide > 0 && (
                    <button
                        onClick={prevSlide}
                        className="absolute left-2 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-70 rounded-full p-1 shadow-md"
                    >
                        <ChevronLeft size={20} />
                    </button>
                )}

                {activeSlide < postData.assets.length - 1 && (
                    <button
                        onClick={nextSlide}
                        className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-70 rounded-full p-1 shadow-md"
                    >
                        <ChevronRight size={20} />
                    </button>
                )}

                {/* Indicator dots */}
                {postData.assets.length > 1 ?
                    <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-1">
                        {postData.assets.map((_, index) => (
                            <div
                                key={index}
                                className={`h-2 w-2 rounded-full ${activeSlide === index ? 'bg-blue-500' : 'bg-gray-300'}`}
                            />
                        ))}
                    </div> : null
                }
            </div>

            {/* Action buttons */}
            <div className="p-3">
                <div className="flex justify-between mb-2">
                    <div className="flex space-x-4">
                        <Heart className="w-6 h-6" />
                        <MessageCircle className="w-6 h-6" />
                        <Send className="w-6 h-6" />
                    </div>
                    <Bookmark className="w-6 h-6" />
                </div>

                {/* Likes */}
                <div className="font-semibold text-sm">{metrics?.likes || 0} likes</div>

                {/* Caption */}
                <div className="text-sm mt-1">
                    <span className="font-semibold">{account?.username}</span> {postData.caption}
                </div>

                {/* Comments and time */}
                <div className="text-gray-500 text-sm mt-1">
                    View all {metrics?.comments || 0} comments
                </div>
                <div className="text-gray-400 text-xs mt-1"><DisplayRelativeTime time={post_at} /></div>
            </div>
        </div>
    );
};


export default InstagramPostPreview;
